import {dateTime, duration} from "services/date";
import {SponsorshipTier} from "types/SponsorshipTier";

/**
 * Transform the given sponsorship tier by deserializing object properties
 *
 * @internal
 * @param sponsorshipTier
 */
export default function deserializeSponsorshipTier(sponsorshipTier: any): SponsorshipTier {
    sponsorshipTier.duration = duration(sponsorshipTier.duration.iso)
    sponsorshipTier.created_at = dateTime(sponsorshipTier.created_at)
    sponsorshipTier.updated_at = dateTime(sponsorshipTier.updated_at)

    return sponsorshipTier;
}